
(function ($) {

    window.smoothScrollToElement = function (selector) {
        var target = $(selector);

        if (target.length) {

            //pre calculated offset
            var headerOffset = parseInt(target.css("scroll-margin-top"), 10);
            var targetOffset = target.offset().top;
            var calculatedOffset = targetOffset - headerOffset;

            //compensating for unknown pixel offset
            calculatedOffset = calculatedOffset + 1;

            $('html, body').animate({
                scrollTop: calculatedOffset
            }, 400, function () {
                // Callback after animation 
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                };
            });
        }
    }

    $(document).ready(function () {
        $(document).on('click', '[data-scroll-to]', function () {
            var selector = $(this).attr('data-scroll-to');
            smoothScrollToElement(selector);
        });
    });
})($JQ);